import SlideShow from './SlideShow';
import SlideShowWithFetch from './SlideShowWithFetch';

export default SlideShow;
export { SlideShowWithFetch };
